import ApplicationController from "../application_controller.js";

export default class extends ApplicationController  {
  static targets = [ "input", "addButton", "subtractButton" ];

  static values = {
    default: { type: Number, default: 0 },
  };

  connect() {
    this.log_function("connect");

    this.boundHandleTyping = this.handleTyping.bind(this);
    this.inputTarget.addEventListener("keypress", this.boundHandleTyping);
    this.inputTarget.setAttribute("inputmode", "numeric");
    if(!this.currentValue) this.inputTarget.value = this.defaultValue;
    this.checkButtons();
  }

  add(event){
    this.log_function("add", event);

    event.preventDefault();
    this.inputTarget.value++;
    this.checkButtons();
  }

  subtract(event) {
    this.log_function("subtract", event);

    event.preventDefault();
    this.inputTarget.value--;
    this.checkButtons();
  }

  disconnect(){
    this.log_function("disconnect");

    this.inputTarget.removeEventListener("keypress", this.boundHandleTyping);
  }

  handleTyping(event){
    this.log_function("handleTyping", event);

    this.checkButtons();
    this.disallowSpecialCharacters(event);
  }

  checkButtons() {
    this.log_function("checkButtons");

    this.subtractButtonTarget.disabled = this.currentValue <= this.minValue;
    this.addButtonTarget.disabled = this.currentValue >= this.maxValue;
  }

  disallowSpecialCharacters(event){
    this.log_function("disallowSpecialCharacters", event);

    const invalidChars = [ "-", "+", "e" ];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }


  get currentValue(){
    this.log_function("get currentValue");

    return parseInt(this.inputTarget.value);
  }

  get minValue(){
    this.log_function("get minValue");

    return parseInt(this.inputTarget.getAttribute("min")) || Number.MIN_VALUE;
  }

  get maxValue() {
    this.log_function("get maxValue");

    return parseInt(this.inputTarget.getAttribute("max")) || Number.MAX_VALUE;
  }
}
